import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Box, Avatar, Hidden, IconButton, Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';
import MenuIcon from '@mui/icons-material/Menu';
import { useConsumption } from './Components/ConsumptionContext';
import { logout } from 'src/actions/accountActions';

const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer - 100,
    boxShadow: 'none',
  },
  toolbar: {
    minHeight: 64
  }
}));

const Header = ({
  className,
  onMobileNavOpen,
  ...rest
}) => {
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = useState(null);
    const history = useNavigate();
    const consumption = useConsumption();
    const accessToken = localStorage.getItem("accessToken");

    /*const handleLogout = () => {
        //localStorage.removeItem('accessToken');
        localStorage.clear();
        delete axios.defaults.headers.common.Authorization;

        dispatch(clearUser());

        navigate("/"); // Navigera till startsidan
        window.location.reload();
    };*/

    const handleLogout = async () => {
      try {
        await dispatch(logout());
        history('/');
      } catch (error) {
        console.log(error);
      }
    };

    const handleMenuOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleMenuClose = () => {
      setAnchorEl(null);
    };
  
    // Skapa initialer från för- och efternamn
    const getInitials = (firstname, lastname) => {
      return (firstname[0] + (lastname ? lastname[0] : '')).toUpperCase();
    };

    return (
        <AppBar
        className={clsx(classes.root, className)}
        {...rest}
        >
            <Toolbar className={classes.toolbar}>
            <Hidden lgUp>
            <IconButton edge="start" color="inherit" aria-label="menu" onClick={onMobileNavOpen}>
            <MenuIcon />
            </IconButton>
            </Hidden>
            <Hidden lgDown>
            <Typography variant="h6" component="h1" sx={{ flexGrow: 1 }}>
            Energiförbrukning – Lägenhetsöversikt
            </Typography>
            {consumption && (
                <Typography variant="subtitle2" color="inherit" sx={{mr: 2}}>
                Fastighetsägare: {consumption.propertyOwnerName} | 
                Fastighet: {consumption.propertyName} | 
                Lägenhet: {consumption.apartmentName}
                </Typography>
            )}
            {accessToken &&
            <Button variant="contained" onClick={handleLogout}>Logga ut</Button>
            }
            </Hidden>
            <Hidden lgUp>
            {consumption && (
                <Typography variant="subtitle2" color="inherit">
                {consumption.propertyName} |&nbsp;
                {consumption.apartmentName}
                </Typography>
            )}
            <Box flexGrow={1}/>
            {accessToken &&
            <Button variant="contained" onClick={handleLogout}>Logga ut</Button>
            }
            </Hidden>
            </Toolbar>
        </AppBar>
    );
};

export default Header;